/* SitesViewComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./SitesViewRenderer");
const PagingFeed = require("./PagingSiteFeed");
const DateColumn = require("./column_renderers/date/DateComponent");
const PathColumn = require("./column_renderers/path/PathComponent");

class SitesViewComponent extends EventEmitter {
    constructor(
        logger,
        gameEditor,
        userSession,
        MUF,
        solutionsManager,
        storageFactory,
        SiteEntity
    ) {
        super();
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._modalUserFeedback = MUF;

        this._userSession = userSession;
        this._storageFactory = storageFactory;
        this._osImageServerFeed = undefined;
        this._engineZoneFeed = undefined;
        // TODO Quick hack to customize DeviceDetailsView based on its parent solution (Device Manager or Config Drift)
        // To be refactored with separate views once form layout / style specifications have matured
        this._solutionDefinition = solutionsManager.getActiveSolution();
        this._solutionName = this._solutionDefinition.name || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "sitesView";
        this._device = undefined;
        this._site = undefined;
        this._renderer = new Renderer(this);
        this._SiteEntity = SiteEntity;
        this._registerListeners();
    }

    get columnConfig() {
        if (this.columns) {
            return this.columns;
        }
        this.columns = {
            grouping: {
                label: "Group",
                width: 220,
                priority: 0,
                shown: false,
                entityColumn: true,
                isGroupingColumn: true,
            },
            locationType: {
                label: "Type",
                width: 45,
                resizable: true,
                priority: 1,
                groupable: true,
                shown: true,
            },
            codeName: {
                label: "Code Name",
                width: 220,
                shown: true,
                priority: 2,
            },
            name: {
                label: "Name",
                shown: true,
                width: 300,
                priority: 3,
            },
            uniqueName: {
                label: "Unique Name",
                groupable: false,
                shown: false,
                width: 140,
                priority: 4,
            },
            description: {
                label: "Description",
                groupable: false,
                shown: true,
                width: 140,
                priority: 5,
            },
            path: {
                label: "Path",
                groupable: true,
                shown: true,
                width: 140,
                priority: 6,
                columnRendererComponent: PathColumn,
            },
            parentName: {
                label: "Parent Site Name",
                groupable: false,
                shown: false,
                width: 140,
                priority: 7,
            },
            adminContact: {
                label: "Admin Contact",
                groupable: true,
                shown: false,
                width: 140,
                priority: 8,
            },
            technicalContact: {
                label: "Technical Contact",
                groupable: true,
                shown: false,
                width: 140,
                priority: 9,
            },
            location: {
                label: "Location",
                groupable: true,
                shown: true,
                width: 140,
                priority: 10,
            },
            address: {
                label: "Address",
                groupable: false,
                shown: false,
                width: 140,
                priority: 11,
            },
            country: {
                label: "Country/Region",
                groupable: true,
                shown: false,
                width: 140,
                priority: 12,
            },
            latitude: {
                label: "Latitude",
                groupable: false,
                shown: false,
                width: 140,
                priority: 13,
            },
            longitude: {
                label: "Longitude",
                groupable: false,
                shown: false,
                width: 140,
                priority: 14,
            },
            timezone: {
                label: "Timezone",
                groupable: true,
                shown: false,
                width: 140,
                priority: 15,
            },
            // autoAssignEnabled: {
            //     label: "Auto-assign Device Enabled",
            //     groupable: false,
            //     shown: false,
            //     width: 140,
            //     priority: 16
            // },
            // autoAssignProperty: {
            //     label: "Auto-assign Device Property",
            //     groupable: true,
            //     shown: true,
            //     width: 140,
            //     priority: 17
            // },
            // autoAssignRegex: {
            //     label: "Auto-assign Device RegEx",
            //     groupable: false,
            //     shown: false,
            //     width: 140,
            //     priority: 18
            // },
            deviceCount: {
                label: "Devices",
                groupable: false,
                shown: true,
                width: 140,
                priority: 19,
            },
            childSiteCount: {
                label: "Sites",
                groupable: false,
                shown: true,
                width: 140,
                priority: 19,
            },
            updatedOn: {
                label: "Updated On",
                groupable: false,
                shown: true,
                width: 140,
                priority: 19,
                columnRendererComponent: DateColumn,
            },
            updatedBy: {
                label: "Updated By",
                groupable: false,
                shown: true,
                width: 140,
                priority: 19,
            },
            createdOn: {
                label: "Created On",
                groupable: false,
                shown: false,
                width: 140,
                priority: 19,
                columnRendererComponent: DateColumn,
            },
            createdBy: {
                label: "Created By",
                groupable: false,
                shown: false,
                width: 140,
                priority: 19,
            },
        };
        return this.columns;
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {}

    _unregisterListeners() {}

    _registerSiteListeners() {}

    _unregisterSiteListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    async shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown().then(
            () => {
                this._logger = undefined;
                this._gameEditor = undefined;
                this._renderer = undefined;
            },
            (err) => {
                this._logger.warn(err, "SiteDetailsViewComponent.shutdown() error.");
            }
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    isDirty() {
        return this._site.isDirty();
    }

    get gameEditor() {
        return this._gameEditor;
    }

    get logger() {
        return this._logger;
    }

    async whenModelIsReady() {
        await this._gameEditor.whenSiteIsReady();
        this._site = this._gameEditor.getSite();

        this._userGridData = this._storageFactory.getRemoteStorageInstanceForEntityGrid(
            "entity_grid_gl",
            this._gridKey + "_selected"
        );
        const userSorting = this._userGridData.getSorting() || {};
        this._patchSorting(userSorting);

        this._pagingSitesFeed = new PagingFeed({
            entityDef: this._gameEditor._siteEntity,
            feedKey: this._gridKey + "_feed",
            activeOrgId: this._gameEditor._activeOrgId,
            columnConfig: this.columnConfig,
            sort: userSorting,
            filter: {ascendantIds: this._site.getId()},
        });

        return this._pagingSitesFeed.whenFeedReady();
    }

    _patchSorting(sorting) {
        // add second sorting order by name
        if (sorting && !sorting.name && this.columnConfig.name) {
            sorting.name = 1;
        }
    }

    onUserSorted(sortData) {
        sortData = [].concat(sortData);
        let sort = {};

        sortData.forEach((sortData) => {
            if (!sortData || !sortData.sortColumn || !this.columnConfig[sortData.sortColumn]) {
                return;
            }
            const sortCriteria =
                this.columnConfig[sortData.sortColumn].valuePath ||
                this.columnConfig[sortData.sortColumn].path ||
                sortData.sortColumn;
            sort[sortCriteria] = sortData.sort === "asc" ? 1 : -1;
        });

        this._patchSorting(sort);

        this._pagingSitesFeed.setSort(sort);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = SitesViewComponent;

SitesViewComponent.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.userSession",
    "$teve.ui.userFeedback",
    "$teve.solutionsManager",
    "$teve.storageFactory",
    "$teve.entities.Site",
];

SitesViewComponent.$displayDetails = {
    type: "View",
    name: "Sites",
    icon: "siteexplorer.site",
    shown: true,
    title: "Sites",
    order: 2,
};
